import AuthService from '../../api/auth.service'
import Cookies from 'js-cookie'
import router from '../../router'

// export const namespaced = true

const state = {
     // set token null if user is not logged in
    authToken: Cookies.get('authToken') ,
    refreshAuthToken: Cookies.get('refreshAuthToken')
}

const getters = {
     // return boolen if token is exist or not
    isLoggedIn: (state) => {
        // console.log("authToken typeof | ", typeof(state.authToken))
        if( state.authToken === undefined || state.authToken === null){
            return false;
        }else if( state.authToken === "undefined" || state.authToken === "null"){
            return false;
        }else{
          return true;
        }

    }

}

const actions = {
     //User login method
     login({ commit }, request_data) {
        return AuthService.login(request_data).then(
          user => {
            commit('setToken', user.data.authToken);
            Cookies.set('authToken', user.data.authToken, { expires: 1 });
            commit('setRefreshToken', user.data.refreshToken);
            Cookies.set('refreshAuthToken', user.data.refreshToken, { expires: 1 });

            return Promise.resolve(user);
          },
          error => {
						console.log("error in auth.js | ", error)
            commit('setToken', null);
            Cookies.remove('authToken')
            commit('setRefreshToken', null);
            Cookies.remove('refreshAuthToken')
            return Promise.reject(error);
          }
        );
      },

      signup({ rootState },request_data) {
        const { authToken } =  rootState.auth;
        return AuthService.signup(authToken,request_data).then(
          user => {
            return Promise.resolve(user);
          },
          error => {
            return Promise.reject(error);
          }
        );
      },

      
      checkValidTokenAsync({ commit }, token) {
        return AuthService.checkValidTokenAsync(token).then(
          user => {
            commit('setToken', user.data.authToken);
            Cookies.set('authToken', user.data.authToken, { expires: 1 });
            
            return Promise.resolve(user);
          },
          error => {
						// console.log("error in auth.js | ", error)
            commit('setToken', null);
            Cookies.remove('authToken')
           
            return Promise.reject(error);
          }
        );
      },

      //Refresh token
      getNewToken({commit, rootState}){
        const { refreshAuthToken } =  rootState.refreshAuthToken;
        let request_data = {
          refreshToken: refreshAuthToken
        }
        return AuthService.refreshToken(request_data).then(
          user => {
            commit('setToken', user.data.authToken);
            Cookies.set('authToken', user.data.authToken, { expires: 1 });

            return Promise.resolve(user.data.authToken);
          },
          error => {
            commit('setToken', null);
            Cookies.remove('authToken')
            return Promise.reject(error);
          }
        );
      },

      //log out user
      logout: ({ commit, dispatch }) => {
          
          dispatch('removeCount', null,  { root: true });
          commit('setToken', null);
          commit('setRefreshToken', null);
          commit('setAgentProfile', null);
          // commit('setCount', 0);
          Cookies.remove('authToken')
          Cookies.remove('refreshAuthToken')
          Cookies.remove('agentProfile')
          Cookies.remove('stepCount')
          Cookies.remove('businessInfo')
          Cookies.remove('catalog')
          Cookies.remove('order')
          Cookies.remove('customer')
          Cookies.remove('saleTransaction')
          Cookies.remove('companyInfo')
          Cookies.remove('storeInfo')
          Cookies.remove('pagination')
          Cookies.remove('showProgressBar')
          Cookies.remove('progressBarPercentage'),
          Cookies.remove('accountName'),
          Cookies.remove('preViewInfo'),
          Cookies.remove('productGroupInfo'),
          Cookies.remove('productDetailsInfo'),
          Cookies.remove('preViewData'),
          localStorage.removeItem("preViewData");
          localStorage.removeItem("quickActionCount");
          localStorage.removeItem("preViewInfo");
          Cookies.remove('salesType');

          
          router.push('/login').catch(()=>{});

      }
}

 const mutations = {
     //update state authToken
     setToken: (state, authToken) => {
          state.authToken = authToken;
      },
      setRefreshToken: (state, refreshAuthToken) => {
          state.refreshAuthToken = refreshAuthToken;
      },
      setCount: (state, count) => {
        state.stepCount = count;
    },

      
 }

 export default{
    state,
    getters,
    actions,
    mutations
}